import { defineMessages } from 'react-intl'

export const softwareVersionMessages = defineMessages({
  daVinciTitle: {
    id: 'softwareVersion.daVinciTitle',
    description: 'software version block title',
    defaultMessage: 'SavantOS Version',
  },
  updatesAvailableLabel: {
    id: 'softwareVersion.updatesAvailableLabel',
    description: 'Updates Available block label',
    defaultMessage: 'Updates Available',
  },
  manageUpdatesLabel: {
    id: 'softwareVersion.ManageUpdatesLabel',
    description: 'Manage Updates block label',
    defaultMessage: 'Manage Updates',
  },
  updatedTimeLabel: {
    id: 'softwareVersion.updatedTimeLabel',
    description: 'Updated time peice block label',
    defaultMessage: 'Updated',
  },
  activeConfigurationLabel: {
    id: 'softwareVersion.activeConfigurationLabel',
    description: 'Configuration block label',
    defaultMessage: 'Active Configuration',
  },
  inactiveConfigurationLabel: {
    id: 'softwareVersion.inactiveConfigurationLabel',
    description: 'Configuration block label',
    defaultMessage: 'No Active Configuration',
  },
})
